module.exports = __webpack_public_path__ + "static/media/ini1-180w.cc724aaa.jpg";